import React from 'react';
// Import RecipeInfo and ChefInfo from the loader file
import { RecipeInfo } from '../loaders/useInfo';
import '../styles/recipe.css'; // Adjust import path as needed

// Define the expected structure for the chef object within RecipeInfo
// interface ChefInfo {
//   _id: string;
//   username: string;
//   // Add other chef properties if needed
// }

// Update RecipeInfo to include the chef object
// interface ExtendedRecipeInfo extends RecipeInfo {
//   chef?: ChefInfo; // Make chef optional if it might not always be present
// }

// Use the imported RecipeInfo type directly
const RecipeItemSmall: React.FC<{ recipeInfo: RecipeInfo, onSelect: () => void }> = ({ recipeInfo, onSelect }) => {
  return (
    // Remove relative positioning if not needed for other elements
    <div className='im_res_div' onClick={onSelect}>
      {recipeInfo.images && recipeInfo.images.length > 0 && (
        <img src={recipeInfo.images[0]} alt={recipeInfo.title} className="recipe-thumbnail" />
      )}

      <div className="recipe-content">
        <div>
          <div className="recipe-title-small">{recipeInfo.title}</div>
          {/* Display Chef username */}
          {recipeInfo.chef && (
            <span className="text-xs italic text-gray-500 ml-1">by {recipeInfo.chef.username}</span>
          )}
          <div className="recipe-description-small">
            {/* {recipeInfo.description.length > 100
              ? recipeInfo.description.substring(0, 100) + '...'
              : recipeInfo.description} */}
            {recipeInfo.description}
          </div>
        </div>
        <div className="recipe-footer">
          <div>Difficulty: <strong> {`${recipeInfo.difficulty}/10`} </strong></div> {/* Adjust as necessary */}
          <div>Time: <strong> {`${recipeInfo.time}`} </strong></div> {/* Adjust as necessary */}
        </div>
      </div>

    </div>
  );
};


export default RecipeItemSmall;
